import React from "react";
import POBreadCrumb from "../../Components/PO/POBreadCrumb";
import POListings from "../../Components/PO/POListings";

export default function POListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <POBreadCrumb />
        <POListings />
      </div>
    </React.Fragment>
  );
}
